import { graphql } from "gatsby"
import { EntryScreen } from "../screens"

const EntryPage = ({ data }) => {
  return <EntryScreen entry={data.entry} />
}

export default EntryPage

export const query = graphql`
  query ($id: String) {
    entry: craftEntryInterface(id: { eq: $id }) {
      uid
      title
      uri
      sectionHandle
      typeHandle
      ...basicPageEntry
      ...landingPageEntry
      ...resourcesListingEntry
      ...caseStudiesListingEntry
      ...profileEntrySummary
      ...profileEntryPage
      ...resourcesDefaultEntry
      ...caseStudiesDefaultEntry
    }
  }
`
